<template>
  <div class="module_title">
    <span class="home_about_title" :class="isShowBorderBottom ? 'home_about_title_border': ''">
      <span class="home_about_title1">{{titleStart}}</span>
      <span class="home_about_title2">{{titleEnd}}</span>
    </span>
    <div class="img_wrap" v-if="isShowImgs && imgs.length > 0">
      <img v-for="(item, index) in imgs" :key="index" :src="item.url" alt="">
    </div>
    <div v-else class="home_about_title_desc">{{desc}}</div>
  </div>
</template>

<script>
export default {
  props: {
    titleStart: {
      type: String,
      default: '关于',
    },
    titleEnd: {
      type: String,
      default: '我们'
    },
    desc: {
      type: String,
      default: '一站式全方案，提供金融技术服务'
    },
    isShowImgs: {
      type: Boolean,
      defalut: false
    },
    imgs: {
      type: Array,
      default() {
        return []
      }
    },
    isShowBorderBottom: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
  .module_title{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    /* background-color: #0098FF; */
    /* text-align: center; */
  }
  .home_about_title{
    width: 1.5rem;
    font-size: 0.36rem;
    line-height: 0.36rem;
    font-family: PingFang SC;
    font-weight: 500;
    padding-bottom: 0.2rem;
    margin-bottom: 0.2rem;
    text-align: center;
  }
  .home_about_title_border{
    border-bottom: 1px solid #2F8FEB;
  }
  .home_about_title1{
    color: #0098FF;
  }
  .home_about_title2{
    color: #08304B;
  }
  .home_about_title_desc{
    font-size: 0.175rem;
    line-height: 0.175rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #707070;
    text-align: center;
  }
  .img_wrap{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img_wrap img{
    width: 0.2rem;
    height: 0.2rem;
    display: block;
    margin-right: 0.1rem;
  }
  @media screen and (max-width: 768px) {
    .home_about_title{
      width: 4rem;
      font-size: 0.9rem;
      line-height: 0.9rem;
      font-family: PingFang SC;
      font-weight: 500;
      padding-bottom: 0.2rem;
      margin-bottom: 0.2rem;
      text-align: center;
    }
    .home_about_title_desc{
      font-size: 0.43rem;
      line-height: 0.43rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #707070;
      text-align: center;
    }
  }
</style>